import { useEffect, useState } from "react";
import { IntlPhoneFieldProps } from "./interface";
import "./intlPhoneField.scss";
import { isValidNumberInput } from "../../../constants/utils";
import constant from "../../../constants/constant";

const IntlPhoneField: React.FC<IntlPhoneFieldProps> = ({
    label,
    htmlFor,
    placeholder,
    id,
    disabled = false,
    value,
    onChange,
    defaultCountryCode,
    errors,
    disableDialCode
}) => {
    const [countryCode, setCountryCode] = useState<string>(
        defaultCountryCode || constant?.COUNTRY_CODES[0].code
    );

    // handle the onChange of country code
    const handleCountryCodeChange = (e: any, code: string) => {
        if (code === countryCode) return;
        e.preventDefault();
        setCountryCode(code);
        onChange({ code: code, mobile: "" });
    };
    // end

    //find the flag of selected country
    const findSelectedCountry=(code:string):string=>{
        return constant.COUNTRY_CODES.find((item)=> item.code === countryCode)?.flag || ''
    }

    // Country code drop down
    const CountryDropDown = (): JSX.Element => {
        return (
            <>
                <button
                    className="btn dropdown-button-border dropdown-toggle gap-1"
                    style={{ borderColor: "rgb(189 187 185)", fontWeight: 400, minWidth:"100px" }}
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    disabled={!!(disableDialCode || disabled)}
                >
                      <span>{findSelectedCountry(countryCode)}</span>
                      <span>{countryCode}</span>
                </button>
                <ul className="dropdown-menu">
                    {constant?.COUNTRY_CODES?.map((item) => (
                        <li>
                            <a
                                className="dropdown-item"
                                href="#"
                                onClick={(e) => handleCountryCodeChange(e, item.code)}
                            >
                                <span>{item.flag}</span>
                                <span>{item.label}</span>
                            </a>
                        </li>
                    ))}
                </ul>
            </>
        );
    };
    // end

    // handle onChange the number on the base of country code
    const handleOnchange = (e: any) => {
        let maxNumber: number =
            countryCode === constant?.COUNTRY_CODES[0].code ? 9999999999 : 99999999;
        isValidNumberInput(e.target.value, maxNumber) &&
            onChange({ code: countryCode, mobile: e.target.value });
    };
    // end

    useEffect(() => {
        defaultCountryCode && setCountryCode(defaultCountryCode);
    }, [defaultCountryCode]);

    return (
        <div className="form-group">
            {label && (
                <label
                    className="inputs-label mb-2 fs-16 fw-600  secondary-color"
                    htmlFor={htmlFor}
                >
                    {label}
                </label>
            )}
            <div className="">
                <div className="input-group">
                    {<CountryDropDown />}
                    <input
                        type="text"
                        className="intl-phone-inputs form-control"
                        aria-label="Phone number input with country code dropdown"
                        placeholder={placeholder}
                        id={id}
                        disabled={disabled}
                        value={value}
                        onChange={(e: any) => handleOnchange(e)}
                    />
                </div>
                {errors && <span className="error-text">{errors}</span>}
            </div>
        </div>
    );
};

export default IntlPhoneField;
